import React from 'react';

import { FiftyBadge } from '@components/branding-v3/fifty-badge';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';
import { pxToRem } from '@utils/converters';

type CopyrightFooterProps = { marginTop?: number };

export const CopyrightFooter = ({ marginTop = 8 }: CopyrightFooterProps) => {
  const { t } = useScopedTranslate(locale);
  const currentYear = new Date().getFullYear();

  return (
    <Stack space={4} align="center" style={{ marginTop: pxToRem(marginTop) }}>
      <Text color="textBullet" text={t('copyright', { currentYear })} font="regular12" center />
      <FiftyBadge color="purple50" height={32} />
    </Stack>
  );
};

const locale = {
  en: {
    copyright: 'Copyright © {currentYear}\nPowered by 50skills',
  },
};
